'use strict';

/* NAVIGATION main menu */

const menu = document.querySelector('.navigation__menu');
const moreLi = document.querySelector('.navigation .more');
const submenu = moreLi && moreLi.querySelector('.submenu');
const el = document.querySelector('nav.navigation');

function redistribute() {
    // Вернуть пункты из «Ещё» перед повторным расчётом доступного места.
    while (submenu.firstChild) {
        menu.appendChild(submenu.firstChild);
    }

    moreLi.style.display = 'none';

    if (window.matchMedia('(max-width: 1040px)').matches) {
        return;
    }

    // Если пункты помещаются в основное меню, переносить их в «Ещё» не нужно.
    if (menu.scrollWidth <= menu.clientWidth) {
        return;
    }

    // Перенести в «Ещё» пункты, которым не хватает места в основной строке меню.
    moreLi.style.display = 'block';
    const items = Array.from(menu.children);
    const availableWidth = menu.clientWidth - moreLi.offsetWidth;
    let usedWidth = 0;

    for (const li of items) {
        usedWidth += li.offsetWidth;
        if (usedWidth > availableWidth) {
            submenu.appendChild(li);
        }
    }

    // Не показывать пустую кнопку «Ещё».
    if (!submenu.children.length) {
        moreLi.style.display = 'none';
    }
}

function start() {
    let lastPosition = getComputedStyle(el).position;
    setInterval(() => {
        const current = getComputedStyle(el).position;
        if (current !== lastPosition) {
            redistribute();
            lastPosition = current;
        }
    }, 200);

    // Сразу при запуске и после загрузки шрифтов, а не только по load (после всех картинок): если
    // страница открыта прокрученной, закреплённое меню (fixed-nav, в одну строку) сразу делится на «Ещё».
    // Незакреплённое меню на десктопе переносится в две строки по стилям темы, пункты в «Ещё» не уходят.
    redistribute();
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(redistribute);
    }
    window.addEventListener('load', redistribute);
    window.addEventListener('resize', redistribute);

    // Небольшая задержка позволяет перевести курсор с кнопки на выпадающее подменю.
    let hideTimeout;

    moreLi.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout);
        moreLi.classList.add('show');
    });

    moreLi.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(() => {
            moreLi.classList.remove('show');
        }, 500);
    });
}

// Доставка могла убрать «Ещё» в блоке navigation_more: меню остаётся как есть и переносится по стилям темы.
if (menu && submenu && el) {
    start();
}
